// <svg width="50" height="50" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path d="M2 6H30M2.00781 15.5H30.0078M2.01562 25H30.0156" stroke="white" strokeWidth="3" />
// </svg>

const BurgerIcon: React.FC = () => (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="48" height="48" rx="5" fill="#101820" stroke="white" strokeWidth="2" />
        <rect x="7.9422" y="11.6227" width="34" height="2" rx="1" fill="white" />
        <rect x="7.9422" y="23.6227" width="34" height="2" rx="1" fill="white" />
        <rect x="7.9422" y="35.6227" width="34" height="2" rx="1" fill="white" />
    </svg>
)

BurgerIcon.displayName = 'BurgerIcon'

export default BurgerIcon
